import type { Location } from "react-router-dom";

import { signal } from '@preact/signals-react';

export const routerLocation = signal<Pick<Location, "pathname" | "search">>({
  pathname: "",
  search: "",
});
